import { Component, inject } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { SideMenuItem, SubMenu, SubMenuItem } from "@zeraki/zeraki-ui";
import { SchoolInfoService } from "src/app/core/services/school-info.service";
import { UserPermissionsService } from "src/app/core/services/user-permissions.service";
import { UserRoleService } from "src/app/core/services/user-role.service";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-side-menu",
	imports: [TranslatePipe, SideMenuItem, SubMenu, SubMenuItem],
	templateUrl: "./side-menu.component.html",
})
export class SideMenuComponent {
	private schoolInfoService = inject(SchoolInfoService);
	public userRole = inject(UserRoleService);
	public userPermissions = inject(UserPermissionsService);

	school = this.schoolInfoService.getSchool();

	isBeta = localStorage.getItem("beta") === "true";
	isTest = !environment.production;
}
